import { call } from '../core'

export enum PinType {
  HALF = 'HALF',
  TEXT = 'TEXT',
}

export enum PinClass {
  LOGIN = 'LOGIN',
  DEBIT_CARD = 'DEBIT_CARD',
  TRANSFER = 'TRANSFER',
}

export enum HostType {
  BANK_API = '0',
  CUSTOMER_API = '1',
}

export enum PinCodeName {
  DEBIT_CARD_PIN_NO = 'debitCardPinNo',
  TR_PIN_NO = 'trPinNo',
}

export interface IRequestPinAuthParams {
  pinType: PinType
  pinClass: PinClass
  title: string
  description: string
  hostType: HostType
  apiUrl: string
  pinCodeName: PinCodeName
  request: string // JSON string
  version?: string
}

export enum RequestPinAuthAction {
  AUTH_FAIL = 'AUTH_FAIL', // PIN 입력 5회 실패 (2102, 3102 - PIN_EXCEED_ERROR)
  AUTH_SUCCESS = 'AUTH_SUCCESS', // API success with PIN
  AUTH_ERROR = 'AUTH_ERROR', // API error (7xxx(Debit Card), 8xxx(Pay Bills))
  CLOSE = 'CLOSE', // PIN 입력 화면에서 닫기 버튼 선택
  FORGOT = 'FORGOT', // PIN 입력 화면에서 Forgot PIN 선택
}

/** response format according to RequestPinAuthAction value
 * (AUTH_SUCCESS) response: content
 * (AUTH_ERROR) response: {code, message, content: {...}}
 * */
export interface IRequestPinAuthInfo {
  action: RequestPinAuthAction
  pincode: string | ''
  response: string // JSON string
}

export interface IRequestPinAuthResult {
  result: IRequestPinAuthInfo | null
}

export function requestPinAuth(
  params: IRequestPinAuthParams,
): Promise<IRequestPinAuthResult | Error> {
  return call('finRequestPinAuth', params)
}
